var map = {
	"./assets/AlienShooting/alien-purple.png": "5a09",
	"./assets/AlienShooting/shoot.wav": "24ed",
	"./assets/SnakeGame/eat.wav": "63b9",
	"./assets/TicTac/enter.wav": "4239",
	"./assets/TicTac/start.wav": "1db8",
	"./assets/TicTac/win.wav": "4f72",
	"./assets/TicTac/win2.wav": "3f48",
	"./assets/cardBack.jpg": "ce25",
	"./assets/fonts/ARCADECLASSIC.TTF": "9536",
	"./assets/logo-dark.svg": "2224",
	"./assets/mastermind.png": "e01f",
	"./assets/mastermindd.png": "b580",
	"./assets/menu-btn.svg": "e25a",
	"./assets/scss/Backgrounds/Background1.svg": "b08e",
	"./assets/scss/global.scss": "b751",
	"./assets/scss/theme-colors.scss": "d1da",
	"./assets/snakegame.png": "7996",
	"./assets/space-invadors.png": "f0c0",
	"./assets/tictactoe.png": "3535"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";